import React from 'react';

import '../../../sass/agentSignatures/title.scss';

const Title = ({ children, className }) => {
    return <div className={className || 'title'}>{children}</div>;
};

export default Title;
